import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Working = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 250, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 120%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='workingmainprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="workingmainchld">

                        <div className="imgleftworking">
                            <img className='img-fluid' src="\assets\Browse\workingflowimg2.png" alt="" />
                        </div>

                        <div className="rightcntworking">
                            <h2>How It Works</h2>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[0] = el)}>
                                <h3>1. Enable Secure Browsing</h3>
                                <p>Activate the feature directly from the app or platform</p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[1] = el)}>
                                <h3>2. Set Your Privacy Preferences</h3>
                                <p>Customize the protection level, from ad-blocking to complete anonymity.</p>
                            </div>
                            <div className="leftcntchldworking" ref={(el) => (cardRefs.current[2] = el)}>
                                <h3>3. Browse Freely</h3>
                                <p>Enjoy fast, private browsing without ads or restrictions.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Working